export const NODE_GAP = 260;
export const DISTANCE = NODE_GAP;
export const NODE_MIN_HEIGHT = 200;
export const NODE_MIN_WIDTH = 500;
export const NODES_CONTAINER_MARGIN = 20;
export const NODE_DRAG_THRESHOLD = 9;
export const DURATION_FOR_VIEW = 1000;
export const MIN_ZOOM = 0.3;
export const MAX_ZOOM = 2;
export const DEFAULT_ZOOM = 0.895;
export const FIFTY_PERCENT_PADDING = 2.34;
export const DUMMY_NODE = 'dummy';
export const PREVIEW_NODE = 'preview';
export const REACT_FLOW_BOUNDS = {
  x: 0,
  y: -20,
  width: NODE_MIN_WIDTH + 80,
  height: 1200,
};

export const BOARD_ID_SELECTORS = {
  SPARK_BOARD_NODE: 'spark-board-node',
  SPARK_BOARD_NODE_CONTENT: 'spark-board-node-content',
  NODE_WITH_CODE_PANEL_WRAPPER_PREFIX: 'Node-With-Code-Panel-Wrapper',
  BOARD_CHAT_CLASS: 'board-chat-container',
  PROMPT_FIELD_ID: 'prompt-field-id',
  SPARK_BOARD_NODE_CONTAINER: 'spark-board-node-container',
} as const;
